import React from 'react';
import PropTypes from 'prop-types';

export default class DialogForm extends React.Component {
  static propTypes = {
    cancelFunction: PropTypes.func.isRequired,
    content: PropTypes.node.isRequired,
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    modalClassName: PropTypes.string,
  };

  static defaultProps = {
    modalClassName: '',
  };

  getModalClass = () => {
    const { show } = this.props;
    if (show) {
      return 'modal fade in';
    }
    return 'modal fade';
  };
  getBackdropClass = () => {
    const { show } = this.props;
    if (show) {
      return 'modal-backdrop fade in';
    }
    return 'modal-backdrop fade';
  };

  catchDialogClick = evt => {
    const { cancelFunction } = this.props;
    const clickedNode = evt.target;
    const classes = clickedNode.getAttribute('class');
    if (classes === 'modal fade in') {
      cancelFunction();
    }
  };

  render() {
    const { cancelFunction, modalClassName, content, show, title } = this.props;

    return (
      <div>
        <div
          className={show ? 'modal fade in' : 'modal fade'}
          role="dialog"
          aria-hidden="true"
          onClick={this.catchDialogClick}
        >
          <div
            className={modalClassName ? `modal-dialog ${modalClassName}` : 'modal-dialog'}
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={cancelFunction}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 className="modal-title">{title}</h4>
              </div>
              <div className="modal-body">{content}</div>
            </div>
          </div>
        </div>
        <div className={show ? 'modal-backdrop fade in' : 'modal-backdrop fade'} />
      </div>
    );
  }
}
